import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import VueSocketio from 'vue-socket.io'

import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import 'bulma-pageloader'

import tokenLogin from '@/components/security/tokenLogin'

import Admin from '@/components/page/Admin'
import AdminQuestions from '@/components/page/AdminQuestions'
import Resultats from '@/components/page/Resultats'
import ResultatsPublic from '@/components/page/ResultatsPublic'
import Home from '@/components/page/Home'
import Repondre from '@/components/page/Repondre'
import VueQriously from 'vue-qriously'

// Import de mon hack perso css bulma
require('@/assets/css/perso.css')

Vue.use(Router)
Vue.use(Buefy, { defaultIconPack: 'fa' })
Vue.use(VueQriously)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path:
        window.location !== window.parent.location
          ? '/p-:urlparticipant/:languageColidee'
          : '/p-:urlparticipant',
      name: 'repondre',
      component: Repondre
    },
    {
      path: '/r-:urlparticipant/:language',
      name: 'resultatsPublic',
      component: ResultatsPublic,
      beforeEnter: (to, from, next) => {
        Vue.use(VueSocketio, process.env.NODE_SERVEUR)
        document.getElementsByTagName('html')[0].style.overflowX = 'hidden'
        // store.commit('board/LAUNCH_MEETING',{url : to.params.url})
        next()
      }
    },
    {
      path: '/resultats-:url_moderateur',
      name: 'resultats',
      component: Resultats,
      beforeEnter: (to, from, next) => {
        Vue.use(VueSocketio, process.env.NODE_SERVEUR)
        document.getElementsByTagName('html')[0].style.overflowX = 'hidden'
        // store.commit('board/LAUNCH_MEETING',{url : to.params.url})
        next()
      }
    },
    {
      path: '/tokenLogin',
      name: 'tokenLogin',
      component: tokenLogin
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      beforeEnter: (to, from, next) => {
        if (store.getters.isLogged) {
          document.getElementsByTagName('html')[0].style.overflowX = 'auto'
          next()
        } else {
          window.location = process.env.URL_SSO_FRONT
        }
      }
    },
    {
      path: '/questions-:url_moderateur',
      name: 'questions',
      component: AdminQuestions,
      beforeEnter: (to, from, next) => {
        Vue.use(VueSocketio, process.env.NODE_SERVEUR)
        document.getElementsByTagName('html')[0].style.overflowX = 'hidden'
        // store.commit('board/LAUNCH_MEETING',{url : to.params.url})
        next()
      }
    },
    {
      path: '/admin/questions',
      name: 'AdminQuestions',
      component: AdminQuestions,
      beforeEnter: (to, from, next) => {
        if (store.getters.isLogged) {
          document.getElementsByTagName('html')[0].style.overflowX = 'hidden'
          next()
        } else {
          window.location = process.env.URL_SSO_FRONT
        }
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js